/* global Backbone */
App.Routers.Store = Backbone.Router.extend({
  default: function (venueId) {
    App.initVenue(venueId);
  },
});
